import { render } from "./ChinhSachVpos.vue?vue&type=template&id=076f85f2"
import script from "./ChinhSachVpos.vue?vue&type=script&lang=js"
export * from "./ChinhSachVpos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__